import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from './RevenuePerNightCard.module.scss';
import { GET_REVENUE_PER_AVAILABLE_NIGHT_REQUEST } from '../../../../../../redux/actions';
import { N30D, L30D } from '../../../../../../utils/constants/filterConstants';
import { Highlight } from '../../../../../common/BasicHighlight/BasicHighlight';
import { revenuePerAvailableNightSelector } from '../../../../../../redux/selectors/revenuePerAvailableNightSelector';
import { Divider } from '@mui/material';
import { isMobileModeSelector } from '../../../../../../redux/selectors/appStatusSelector';
import { performancePagePeriodSelector } from '../../../../../../redux/selectors/performancePageSelector';
import { Typography } from '../../../../../../shared/ui/typography';
import { AlertIcon } from '../../../../../../assets/icons/AlertIcon';
import { HigherIcon } from '../../../../../../assets/icons/HigherIcon';
import clsx from 'clsx';
import { listingsSelector } from '@/redux/selectors/listingsSelector';
import { IListing } from '@/views/interfaces';
import { useMemo } from 'react';

export const RevenuePerNightCard = () => {
  const dispatch = useDispatch();
  const period = useSelector(performancePagePeriodSelector);
  const data = useSelector(revenuePerAvailableNightSelector(period))?.summary?.[0];
  const isMobileView = useSelector(isMobileModeSelector);
   
  var per_night_revenue = '';
  var per_night_revenue_stly = '';
  if(period == 'last 12 months'){
      per_night_revenue = data?.revpar_ytd;  
      per_night_revenue_stly = data?.revpar_ytd_stly;      
  }else if(period == 'next 30 days'){
    per_night_revenue = data?.revpar_n30;
    per_night_revenue_stly = data?.revpar_n30_stly;    
  }
  else{
    per_night_revenue = data?.revpar_l30; 
    per_night_revenue_stly = data?.revpar_l30_stly; 
  }

  // console.log("Data: ", per_night_revenue_stly);
   const listings: IListing[] = useSelector(listingsSelector);
    const body = useMemo(() => {
      return (listings !== null ? listings : [])
        .filter((listing) => listing.is_listed)
        .map((listing) => listing.property_id);
    }, [listings]);

  useEffect(() => {
    dispatch({
      type: GET_REVENUE_PER_AVAILABLE_NIGHT_REQUEST,
      payload: body,
    });
  }, [dispatch, body]);

  if ((per_night_revenue_stly == undefined || per_night_revenue_stly == null) && (per_night_revenue == undefined || per_night_revenue == null)) {
    return (
      <div
        className={clsx(classes.cardContainer, classes.errorMessageContainer)}
      >
        <Typography
          variant='text-lg'
          weight='medium'
          className={classes.noDataMessage}
        >
          No data available for the selected period.
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.cardContainer}>
      <div className={classes.cardHeader}>
        <Typography
          variant={isMobileView ? 'text-md' : 'text-xl'}
          weight='semibold'
          className={classes.gray900}
        >
          Revenue per available night
        </Typography>
        { (per_night_revenue > per_night_revenue_stly) ? 
          <div className={classes.success }>          
            <HigherIcon />
            <Typography variant='text-xs' className={classes.success_text}>
              RevPAN is higher than last year
            </Typography>
          </div> :
          <div className={classes.warning}>
            <AlertIcon />
            <Typography variant='text-xs' className={classes.error500}>
              RevPAN is lower than last year
            </Typography>
          </div>
        }
        
      </div>
      <div className={classes.cardBody}>
        {(per_night_revenue !== undefined && per_night_revenue !== null) && (
          <Highlight
            className={classes.highlight}
            label='RevPAN'
            currency
            reverse
            tooltip={
              isMobileView
                ? undefined
                : 'This is the Revenue received Per Available Night. This number is calculated by taking into account both the Average Rate at which the property was Booked (ADR) and the Number of Nights it was Booked and subtracting the Owner Nights. '
            }
            value={per_night_revenue}
            previousValue={per_night_revenue_stly}
            showDynamicIndicator={period !== N30D && period !== L30D}            
            {...(per_night_revenue > per_night_revenue_stly ? { showHigherIcon: true } : { showAlertIcon: true }) }
          />
        )}
        {(per_night_revenue_stly !== undefined && per_night_revenue_stly !== null) ? <Divider orientation={isMobileView ? 'horizontal' : 'vertical'} /> : ''}
        {(per_night_revenue_stly !== undefined && per_night_revenue_stly !== null) && (
          <Highlight
            className={classes.highlight}
            label='RevPan Last Year'
            currency
            reverse
            tooltip={
              isMobileView
                ? undefined
                : 'This is the Revenue received Per Available Night. This number is calculated by taking into account both the Average Rate at which the property was Booked (ADR) and the Number of Nights it was Booked and subtracting the Owner Nights. ' //TODO: change tooltip text
            }
            value={per_night_revenue_stly}
            previousValue={per_night_revenue_stly}
            showDynamicIndicator={period !== N30D && period !== L30D}
          />
        )}
      </div>
    </div>
  );
};
